/* Locomotive Scroll's browser build looks for Lenis as window.lenis */
window.lenis = window.lenis || window.Lenis;
